import { useQuery } from "@tanstack/react-query";
import { ExtractFnReturnType, QueryConfig } from "../../../../lib/react-query";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { PaginationFilterDto } from "../../../../types/Pagination";
import { getUserCommunicationTypes } from "../api/userCommunicationTypeApi";

type QueryFnType = typeof getUserCommunicationTypes;

type UseSearchUserCommunicationTypesOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useUserCommunicationTypes = ({ config }: UseSearchUserCommunicationTypesOptions = {}) => {
    const selectedFilters = useSelector((state: RootState) => state.filters.userCommunicationTypes.selectedFilters);
    const pagination = useSelector((state: RootState) => state.historical.userCommunicationTypes);
    const filterByOnlyActiveRecords = useSelector((state: RootState) => state.filters.userCommunicationTypes.filterByOnlyActiveRecords);

    const paginationFilters: PaginationFilterDto =
    {
        pageNumber: pagination.currentPage,
        pageSize: pagination.itemsPerPage,
        search: pagination.searchText,
        filterByOnlyActiveRecords: filterByOnlyActiveRecords,
        filters: selectedFilters,
        selectedOrganizationalStructureIds: []
    };

    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ['getUserCommunicationTypes', selectedFilters, pagination, filterByOnlyActiveRecords],
        queryFn: () => getUserCommunicationTypes(paginationFilters),
    });
};